/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
    enabled: true, // set false to disable splash screen
    animation: splashAnimation,
    duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
    animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Murat Uluğ",
  title: "Hi all, I'm Murat",
  subTitle: emoji(
    "A passionate Senior Software Developer 🚀 having an experience of building Web and Mobile applications with TypeScript / JavaScript /  React Native /Reactjs  / Angular / Nodejs / .Net / .Net Core and some other cool libraries and frameworks."
  ),
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
    github: "https://github.com/MuratUlugg",
    linkedin: "https://www.linkedin.com/in/muratulug/",
    gmail: "ulugyazilim@gmail.com",
    medium: "https://medium.com/@murat.ulug",
    // Instagram, Twitter and Kaggle are also supported in the links!
    // To customize icons and social links, tweak src/components/SocialMedia
    display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
    title: "What I do",
    subTitle: "CRAZY FULL STACK DEVELOPER WHO WANTS TO EXPLORE EVERY TECH STACK",
    skills: [
        emoji(
            "⚡ Develop highly interactive Front end / User Interfaces for your web and mobile applications"
        ),
        emoji("⚡ Progressive Web Applications ( PWA ) in normal and SPA Stacks"),
        emoji(
            "⚡ Integration of third party services such as Firebase/ AWS / Azure"
        ),
        emoji(
            "⚡ Frontend Technologies: Proficient in TypeScript and JavaScript, expertise in frameworks and libraries such as React, React Native, Angular, and experienced with .NET (C#, VB) including MVC, Web Form, and Win Form development."
        ),
        emoji(
            "⚡ Backend Technologies: Skilled in server-side development using TypeScript and JavaScript (NodeJS), proficient with .NET (C#, VB) and .NET Core (C#) for building scalable backend systems."
        ),
        emoji(
            "⚡ Database Management: Extensive experience with relational and non-relational databases including MsSQL, MongoDb, and PostgreSQL."
        ),
        emoji(
            "⚡ State Management: Expert in managing application state using Redux and Redux Saga."
        ),
        emoji(
            "⚡ Project Management: Utilizing Agile and Scrum methodologies to ensure timely and efficient project delivery."
        ),
        emoji(
            "⚡ Version Control Systems: Proficient in using Git, Svn, and Tfs for source code management."
        ),
        emoji(
            "⚡ Project Control Tools: Skilled in using Redmine, Jira, and Azure DevOps for project tracking and control."
        ),
        emoji(
            "⚡ Service Protocols: Implementing SOAP and REST services for robust communication between systems."
        ),
        emoji(
            "⚡ Service Tools: Skilled in using Postman, WCFStorm, and SoapUI for API testing and debugging."
        )
    ],

    /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

    softwareSkills: [{
            skillName: "Html-5",
            fontAwesomeClassname: "fab fa-html5"
        },
        {
            skillName: "Css3",
            fontAwesomeClassname: "fab fa-css3-alt"
        },
        {
            skillName: "Sass",
            fontAwesomeClassname: "fab fa-sass"
        },
        {
            skillName: "TypeScript",
            fontAwesomeClassname: "fab fa-js"
        },
        {
            skillName: "JavaScript",
            fontAwesomeClassname: "fab fa-js"
        },
        {
            skillName: "React Native",
            fontAwesomeClassname: "fab fa-react"
        },
        {
            skillName: "React",
            fontAwesomeClassname: "fab fa-react"
        },
        {
            skillName: "Angular",
            fontAwesomeClassname: "fab fa-angular"
        },
        {
            skillName: "Vue",
            fontAwesomeClassname: "fab fa-vuejs"
        },

        {
            skillName: "Nodejs",
            fontAwesomeClassname: "fab fa-node"
        },
        {
            skillName: ".Net",
            fontAwesomeClassname: "fab fa-battle-net"
        },
        {
            skillName: ".Net Core",
            fontAwesomeClassname: "fab fa-battle-net"
        },
        {
            skillName: "Swift",
            fontAwesomeClassname: "fab fa-swift"
        },
        {
            skillName: "Kotlin",
            fontAwesomeClassname: "fab fa-swift"
        },
        {
            skillName: "npm",
            fontAwesomeClassname: "fab fa-npm"
        },
        {
            skillName: "mongo-db",
            fontAwesomeClassname: "fas fa-database"
        },
        {
            skillName: "sql-database",
            fontAwesomeClassname: "fas fa-database"
        },
        {
            skillName: "aws",
            fontAwesomeClassname: "fab fa-aws"
        },
        {
            skillName: "firebase",
            fontAwesomeClassname: "fas fa-fire"
        },
        {
            skillName: "docker",
            fontAwesomeClassname: "fab fa-docker"
        }
    ],
    display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Anadolu University",
      logo: require("./assets/images/anadoluuniv_logo.jpeg"),
      subHeader: "Bachelor's Degree, Management Information Systems",
      duration: " 2017"
    },
    {
      schoolName: "Akdeniz University",
      logo: require("./assets/images/akdeniz_universitesi_logo.jpeg"),
      subHeader: "Computer Programming",
      duration: "2013 - 2015"
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
    viewSkillBars: true, //Set it to true to show Proficiency Section
    experience: [{
            Stack: "Mobile", //Insert stack or technology you have experience in
            progressPercentage: "90%" //Insert relative proficiency in percentage
        },
        {
            Stack: "Frontend", //Insert stack or technology you have experience in
            progressPercentage: "80%" //Insert relative proficiency in percentage
        },
        {
            Stack: "Backend",
            progressPercentage: "80%"
        },
        {
            Stack: "Database",
            progressPercentage: "80%"
        },
        {
            Stack: "Programming",
            progressPercentage: "90%"
        }
    ],
    displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Senior Software Developer",
      company: "Param",
      companylogo: require("./assets/images/paramtech_logo.jpeg"),
      date: "Sep 2023 – Present",
      desc: "Full Time"
    },
    {
      role: "Full Stack Developer",
      company: "Univera",
      companylogo: require("./assets/images/univeratechnology_logo.jpeg"),
      date: "May 2021 – Sep 2023",
      desc: "Full Time"
    },
    {
      role: "Software Developer",
      company: "Veri Yazilim",
      companylogo: require("./assets/images/kerzzpos_logo.jpeg"),
      date: "Jun 2016 – May 2021",
      desc: "Full Time"
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
    showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
    display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
  projects: [
    {
      image: require("./assets/images/kredimcomtr_logo.jpeg"),
      projectName: "Kredim",

      footerLink: [
        {
          name: "Visit Website",
          url: "https://www.kredim.com.tr/"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/paramtech_logo.jpeg"),
      projectName: "Param",

      footerLink: [
        {
          name: "Visit Website",
          url: "https://param.com.tr/"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/univeratechnology_logo.jpeg"),
      projectName: "Panaroma",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://univera.com.tr/panorama-dunyasi"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
    title: emoji("Achievements And Certifications 🏆 "),
    subtitle: "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

    achievementsCards: [{
            title: "Google Code-In Finalist",
            subtitle: "First Pakistani to be selected as Google Code-in Finalist from 4000 students from 77 different countries.",
            image: require("./assets/images/codeInLogo.webp"),
            imageAlt: "Google Code-In Logo",
            footerLink: [{
                    name: "Certification",
                    url: "https://drive.google.com/file/d/0B7kazrtMwm5dYkVvNjdNWjNybWJrbndFSHpNY2NFV1p4YmU0/view?usp=sharing"
                },
                {
                    name: "Award Letter",
                    url: "https://drive.google.com/file/d/0B7kazrtMwm5dekxBTW5hQkg2WXUyR3QzQmR0VERiLXlGRVdF/view?usp=sharing"
                },
                {
                    name: "Google Code-in Blog",
                    url: "https://opensource.googleblog.com/2019/01/google-code-in-2018-winners.html"
                }
            ]
        },
        {
            title: "Google Assistant Action",
            subtitle: "Developed a Google Assistant Action JavaScript Guru that is available on 2 Billion devices world wide.",
            image: require("./assets/images/googleAssistantLogo.webp"),
            imageAlt: "Google Assistant Action Logo",
            footerLink: [{
                name: "View Google Assistant Action",
                url: "https://assistant.google.com/services/a/uid/000000100ee688ee?hl=en"
            }]
        },

        {
            title: "PWA Web App Developer",
            subtitle: "Completed Certifcation from SMIT for PWA Web App Development",
            image: require("./assets/images/pwaLogo.webp"),
            imageAlt: "PWA Logo",
            footerLink: [
                { name: "Certification", url: "" },
                {
                    name: "Final Project",
                    url: "https://pakistan-olx-1.firebaseapp.com/"
                }
            ]
        }
    ],
    display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
    title: "Blogs",
    subtitle: "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
    displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
    blogs: [{
            url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
            title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
            description: "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
        },
        {
            url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
            title: "Why REACT is The Best?",
            description: "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
        }
    ],
    display: true // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
    title: "TALKS",
    subtitle: emoji(
        "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
    ),

    talks: [{
        title: "Build Actions For Google Assistant",
        subtitle: "Codelab at GDG DevFest Karachi 2019",
        slides_url: "https://bit.ly/saadpasta-slides",
        event_url: "https://www.facebook.com/events/2339906106275053/"
    }],
    display: true // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
    title: emoji("Podcast 🎙️"),
    subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

    // Please Provide with Your Podcast embeded Link
    podcast: [
        "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
    ],
    display: true // Set false to hide this section, defaults to true
};

// Resume Section
const resumeSection = {
    title: "Resume",
    subtitle: "Feel free to download my resume",

    // Please Provide with Your Podcast embeded Link
    display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
    title: emoji("Contact Me ☎️"),
    subtitle: "Discuss a project or just want to say hi? My Inbox is open for all.",
    number: "+92-0000000000",
    email_address: "saadpasta70@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "murattulugg", //Replace "twitter" with your twitter username without @
  display: true // Set true to display this section, defaults to false
};

const isHireable = false; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
    illustration,
    greeting,
    socialMediaLinks,
    splashScreen,
    skillsSection,
    educationInfo,
    techStack,
    workExperiences,
    openSource,
    bigProjects,
    achievementSection,
    blogSection,
    talkSection,
    podcastSection,
    contactInfo,
    twitterDetails,
    isHireable,
    resumeSection
};